
import React, { Component } from 'react';
import VerticalLayout from "../../components/VerticalLayout/";
import ActivityDetailPage from './ActivityDetailPage';

class HotelDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
           
        }        
    }

    componentDidCatch(){
        
        localStorage.getItem("authUser")?this.props.history.push('/hotels'):this.props.history.push('/404')
    }


    render() {
        
        let obj = JSON.parse(localStorage.getItem("authUser"))

        return (
                obj?
                <VerticalLayout>
                    <ActivityDetailPage 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    obj = {obj}
                    />

                </VerticalLayout>

                :

                <ActivityDetailPage 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    obj = {obj}
                />
          
        );
    }
}

export default HotelDetail;
